import { Pipe, PipeTransform } from "@angular/core";
import { AlphanumPipe } from "./alpha-num.pipe";

/**
 * Pipe para ordenar dois valores por números e letras.
 *
 * @author patrick.bard
 */
@Pipe({ name: "orderByNumbersAndLetters" })
export class OrderByNumbersAndLettersPipe implements PipeTransform {
    transform(items: Array<string | number>, caseInsensitive: boolean): Array<string | number> {
        return items.sort((value1, value2) => {
            if (!isNaN(value1 as any)) {
                value1 = parseInt(value1 as string);
            }

            if (!isNaN(value2 as any)) {
                value2 = parseInt(value2 as string);
            }

            const type1 = typeof value1;
            const type2 = typeof value2;

            if (type1 > type2) {
                return -1;
            } else if (type1 < type2) {
                return 1;
            } else if (typeof value1 === "string" && typeof value2 === "string") {
                return new AlphanumPipe().transform(value1, value2, caseInsensitive);
            } else if (!isNaN(value1 as any) && value1 !== value2) {
                return value1 > value2 ? 1 : -1;
            } else {
                return 0;
            }
        });
    }
}
